import React, { Component } from "react";
import { withCompanies } from "../../../shared/containers/containerCompanies";

import ControlPointIcon from "@mui/icons-material/ControlPoint";
import AddTaskIcon from "@mui/icons-material/AddTask";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import Input from "../../../shared/items/contols/input";

import { states } from "../../../reducers/queriesStates";
import styles from "./cmsCompanyTools.module.scss";

class CmsCompanyCreateTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isView: false,
      isError: false,
      title: null,
    };
  }

  componentDidUpdate(prevPeops) {
    const { createCompanyDataState } = this.props;

    if (createCompanyDataState === states.READY && prevPeops.createCompanyDataState === states.REQUEST) {
      this.setState({ isView: false });
    }

    if (createCompanyDataState === states.FAILURE && prevPeops.createCompanyDataState === states.REQUEST) {
      this.setState({ isError: true, isView: false });

      setTimeout(() => {
        this.setState({ isError: false, isView: false });
      }, 3000);
    }
  }

  onChangeTitleCompany(name, title) {
    this.setState({ title });
  }

  onCreateCompany() {
    const { onCreateCompany, ownershipAreaId } = this.props;
    const { title } = this.state;

    if (title !== null && title !== "") {
      onCreateCompany({ title, ownershipAreaId, timeZone: (new Date().getTimezoneOffset() / 60) * -1 });
    }
  }

  render() {
    const { isView, isError } = this.state;

    if (isError) {
      return (
        <div className={styles.createToolsContainer}>
          <div style={{ color: "red" }}>{"Не удалось создать компанию"}</div>
        </div>
      );
    }

    const timeZone = (new Date().getTimezoneOffset() / 60) * -1;

    return !isView ? (
      <div className={styles.createToolsContainer}>
        <TooltipWrapper title={"Создать новую компанию"} position="left">
          <ControlPointIcon
            className={styles.icon}
            fontSize="large"
            onClick={() => {
              this.setState({ isView: !isView });
            }}
          />
        </TooltipWrapper>
      </div>
    ) : (
      <div className={styles.createToolsContainer}>
        <TooltipWrapper title={"Отмена"} position="left">
          <HighlightOffIcon
            className={styles.icon}
            fontSize="large"
            onClick={() => {
              this.setState({ isView: !isView });
            }}
          />
        </TooltipWrapper>
        <div className={styles.inputText}>
          <Input name="ownershipTitle" type="text" placeholder="Новая компания" handleChangeStore={this.onChangeTitleCompany.bind(this)} />
        </div>
        <TooltipWrapper title={"Создать"} position="left">
          <AddTaskIcon className={styles.iconAdd} fontSize="large" onClick={this.onCreateCompany.bind(this)} />
        </TooltipWrapper>
      </div>
    );
  }
}

export default withCompanies(CmsCompanyCreateTools);
